<template>
  <div>
    <div class="box_layer" :class="{end: tourEnd === 'Y'}">
      <!---------------------------------------------------------------- 포인트일 경우 -------------------------------------------------------------------->
      <div class="stamp_box" v-if="setStamp()">
        <div class="title">
            <span @click="goMyStamp">{{guestCheck()}}<img src="@/assets/images/arrow_3.png" alt="arrow" class="myStamp"></span>
            <!-- 스타박스 인증 챌린지 다시하기 안뜨도록 처리 추가 230306 teddy -->
            <span class="count" v-if="getStampCount !== allStampCount || tourRestart === '1'">
                <em>{{myPoint}}</em>
                <img src="@/assets/images/dot.png" alt="dot">
                <em>{{allStampPoint}}</em>
            </span>
            <span class="restart" v-else>
              <button @click="restartPopup()">
                <img src="@/assets/images/restart.png" alt="restart">
                다시시작
              </button>
            </span>
        </div>
        <!-- <div class="title" @click="loginOpen" v-else>스탬프를 찍기 위해 로그인이 필요합니다</div> -->
        <swiper :options="swiperOption" class="swiper">
          <swiper-slide
            class="slide"
            v-for="index in swiperPaging()"
            v-bind:key="index">
              <ul class="stamp_list">
                  <li v-for="index_in in stampCount(index)" v-bind:key="index_in">
                      <div class="box">
                          <img class="round" :style="{ zIndex : zIn(index_in+(index*10-10)) }" :src="completeChk(index_in+(index*10-10))">
                          <img class="gift" v-if="giftChkPoint(index_in+(index*10-10))" :src="giftIconPoint(index_in+(index*10-10))" @click="giftClickPoint(index_in+(index*10-10))">
                          <span v-else>{{index_in+(index*10-10)}}</span>
                      </div>
                      <div class="line" :class="lineChk(index_in+(index*10-10))">line</div>
                  </li>
              </ul>
          </swiper-slide>
          <div class="swiper-pagination" slot="pagination"></div>
        </swiper>
      </div>
      <!----------------------------------------------------------------- 갯수일 경우 -------------------------------------------------------------->
      <div class="stamp_box" v-else>
        <div class="title">
            <span @click="goMyStamp">{{guestCheck()}}<img src="@/assets/images/arrow_3.png" alt="arrow" class="myStamp"></span>
            <!-- 김포 리뉴얼 다시하기 안뜨도록 처리 추가 230126 teddy -->
            <span class="count" v-if="(getStampCount !== allStampCount || tourRestart === '1')">
                <em>{{getStampCount}}</em>
                <img src="@/assets/images/dot.png" alt="dot">
                <em>{{allStampCount}}</em>
            </span>
            <span class="restart" v-else>
              <button @click="restartPopup()">
                <img src="@/assets/images/restart.png" alt="restart">
                다시시작
              </button>
            </span>
        </div>
        <!-- <div class="title" @click="loginOpen" v-else>스탬프를 찍기 위해 로그인이 필요합니다</div> -->
        <swiper :options="swiperOption" class="swiper" id="swiperBox">
          <swiper-slide
            class="slide"
            v-for="index in swiperPaging()"
            v-bind:key="index">
              <ul class="stamp_list">
                  <li v-for="index_in in stampCount(index)" v-bind:key="index_in" class="dot_box">
                      <div class="box">
                          <img class="round" :style="{ zIndex : zIn(index_in+(index*10-10)) }" :src="completeChk(index_in+(index*10-10))">
                          <img class="gift" v-if="giftChk(index_in+(index*10-10)) && mingleCode !== 'aEfzNuaa+h9pVQXWjUlAPQ=='" :src="giftIcon(index_in+(index*10-10))" @click="giftClick(index_in+(index*10-10))">
                          <span v-else>{{index_in+(index*10-10)}}</span>
                      </div>
                      <div class="line" :class="lineChk(index_in+(index*10-10))">line</div>
                  </li>
              </ul>
          </swiper-slide>
          <div class="swiper-pagination" slot="pagination"></div>
        </swiper>
      </div>
      <div v-if="tourEnd === 'Y'" class="end_layer">
        운영 종료
      </div>
    </div>
    <div v-if="tourRange" class="tour_range" :class="{end: tourEnd === 'Y'}">
      <span>투어 기간 : {{ tourRange }}</span>
    </div>
  </div>
</template>
<script>
import { mapState } from 'vuex'
import router from '@/router'
import * as appEvent from '@/assets/js/app_event.js'
export default {
  name: 'MainStamp',
  data () {
    return {
      swiperOption: {
        slidesPerView: 1,
        spaceBetween: 10,
        pagination: {
          el: '.swiper-pagination',
          type: 'fraction'
        }
      },
      tourEnd: 'N', // 종료 여부 Y(종료) N(진행중)
      tourRange: '', // 투어 기간
      tourRestart: '0' // 투어 재도전 가능 여부
    }
  },
  watch: {
    mingleCode () {
      this.$store.dispatch('loadGiftData')
    },
    mainStampInfo () {
      // 종료가 9999일 경우 상시 운영
      const endCheck = this.mainStampInfo.mingle_end.includes('9999') || this.mainStampInfo.mingle_end.includes('2999')
      this.tourEnd = this.mainStampInfo.mingle_season_end_yn
      this.tourRange = `${this.tourDate(this.mainStampInfo.mingle_start)} ~ ${endCheck ? '' : this.tourDate(this.mainStampInfo.mingle_end)}`
      this.tourRestart = this.mainStampInfo.mingle_reset_count
    }
  },
  computed: {
    ...mapState([
      'allStampCount',
      'getStampCount',
      'giftData',
      'token',
      'stampAll',
      'stampCodeInfo',
      'mingleCode',
      'myPoint',
      'allStampPoint',
      'guestChk',
      'mainStampInfo'
    ])
  },
  methods: {
    swiperPaging () {
      let count = 0
      if (this.allStampCount) {
        count = Math.ceil(this.allStampCount / 10)
      }
      return count
    },
    stampList (idx) {
      const end = idx * 10
      const start = end - 10
      return this.stampAll.slice(start, end)
    },
    stampCount (idx) {
      let count = 10
      if (Math.ceil(this.allStampCount / 10) === idx) {
        count = this.allStampCount % 10
        if (count === 0) {
          count = 10
        }
      }
      return count
    },
    giftChk (num) {
      let chk = false
      this.giftData.map((data) => {
        if (parseInt(data.mingle_count) === num) {
          chk = true
        }
      })
      return chk
    },
    giftIcon (num) {
      let gift = ''
      this.giftData.map((data) => {
        if (parseInt(data.mingle_count) === num) {
          gift = `https://tg-s3.tranggle.com/mingle/image/mingle/${data.mingle_gift_image}`
        }
      })
      return gift
    },
    giftIconPoint (num) {
      let gift = ''
      this.giftData.map((data) => {
        if (data.mingle_count - this.myPoint < 6 && data.mingle_count - this.myPoint > 0 && this.getStampCount + 1 === num) {
          gift = `https://tg-s3.tranggle.com/mingle/image/mingle/${data.mingle_gift_image}`
        }
      })
      return gift
    },
    completeChk (num) {
      let complete = ''
      if (num > this.getStampCount) {
        complete = require('@/assets/images/dot_round.png')
      } else {
        complete = require(`@/assets/images/complete${this.tourEnd === 'Y' ? '_end' : ''}.png`)
      }
      return complete
    },
    lineChk (num) {
      let check = ''
      if (num <= this.getStampCount) {
        check = 'completeLine'
      }
      return check
    },
    zIn (num) {
      let zindex = 0
      if (num > this.getStampCount) {
        zindex = 0
      } else {
        zindex = 999
      }
      return zindex
    },
    giftClick (num) {
      // window.history.pushState({}, 'modal', '/modal')
      this.giftData.map((data) => {
        if (parseInt(data.mingle_count) === num) {
          this.$store.dispatch('openPopupGift', data)
        }
      })
    },
    giftClickPoint (num) {
      // window.history.pushState({}, 'modal', '/modal')
      this.giftData.map((data) => {
        if (data.mingle_count - this.myPoint < 6 && data.mingle_count - this.myPoint > 0 && this.getStampCount + 1 === num) {
          this.$store.dispatch('openPopupGift', data)
        }
      })
    },
    setStamp () {
      let tg = false
      this.stampCodeInfo.map((data) => {
        if (data.code === this.mingleCode && data.info === 'point') {
          tg = true
        } else if (data.code === this.mingleCode && data.info === 'number') {
          tg = false
        }
      })
      return tg
    },
    giftChkPoint (num) {
      let chk = false
      this.giftData.map((data) => {
        if (data.mingle_count - this.myPoint < 6 && data.mingle_count - this.myPoint > 0 && this.getStampCount + 1 === num) {
          chk = true
        }
      })
      // 스타박스 스탬프 기프트 이미지 안보이게 처리
      if (this.mingleCode === 'N5ReL9kGxQw9rP/t80LkoA==') {
        chk = false
      }
      return chk
    },
    loginOpen () {
      appEvent.thema10Login()
      // if (/Android/i.test(navigator.userAgent)) {
      //   // eslint-disable-next-line no-undef
      //   tranggle3.tranggle_callback('go_home_event', '{}')
      // } else if (/iPhone|iPad|iPod/i.test(navigator.userAgent)) {
      //   window.location = 'tranggle_callback://go_home_event'
      // } else {
      //   return false
      // }
    },
    goMyStamp () {
      router.push('/mystamp')
    },
    restartPopup () {
      // this.$store.dispatch('chkRestartTour')
      let giftCnt = 0
      let i = 0
      for (i; i < this.giftData.length; i++) {
        if (!this.giftData[i].mingle_gift_add_point && this.giftData[i].mingle_gift_receive === 'Y') {
          giftCnt++
        } else if (this.giftData[i].mingle_gift_add_point && !this.giftData[i].user_gift_request_date) {
          giftCnt++
        }
      }
      this.$store.state.getGiftChk = false
      // if (giftCnt > 0 && this.$store.state.getGiftChk === false) {
      //   this.$store.state.getGiftChk = !this.$store.state.getGiftChk
      // }
      this.$store.state.getGiftCnt = giftCnt
      this.$store.state.restartOpen = !this.$store.state.restartOpen
    },
    guestCheck () {
      let text = ''
      if (this.guestChk === 'Y') {
        text = '손님으로 찍은 스탬프'
      } else {
        text = '내가 찍은 스탬프'
      }
      return text
    },
    tourDate (date) {
      return date && date.split(' ')[0].replaceAll('-', '. ')
    }
  },
  created () {
    // this.$store.dispatch('loadGiftData')
  },
  mounted () {
    if (this.mingleCode) {
      this.$store.dispatch('loadGiftData')
    }
  }
}
</script>
<style scoped>
    .swiper {
        width: 100%;
    }
    .swiper-pagination {
      bottom: 0px;
    }
</style>
